import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=713d1928&scoped=true"
import script from "./Model.vue?vue&type=script&setup=true&lang=js"
export * from "./Model.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Model.vue?vue&type=style&index=0&id=713d1928&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d1928",
  null
  
)

export default component.exports